define('modules/lp_integration/models/integration_mdirector',['require','exports','module','backbone','env'],function(require, exports, module){
  "use strict";

  var Backbone = require("backbone"),
    config = require("env");

  module.exports = Backbone.Model.extend({
    defaults: {
      active: false,
      account: "",
      list: "",
      fields: {},
      welcome_email: false,
      hasDoubleOptin: false,
      allowUpdatingContact: false
    },
    url: function(){
      return [config.apiHost, "pages", this.pageId, "integration", "mdirector"].join("/");
    },
    initialize: function(attrs,options){
      this.pageId = options.pageId;
    },
    toJSON: function(){
      return _.omit(module.exports.__super__.toJSON.apply(this), "id");
    },
    validate: function(attrs){
      var errors = [];
      if(!attrs.account || parseInt(attrs.account) <= 0){
        errors.push({attribute: "account", message: "required"});
      }
      if(!attrs.list || parseInt(attrs.list) <= 0){
        errors.push({attribute: "list", message: "required"});
      }
      if(_.isEmpty(attrs.fields)){
        errors.push({attribute: "fields", message:"required"});
      }
      if(errors.length > 0){
        return errors;
      }
    }
  });
});

